import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

/**
 * 관리자 전용 라우트 가드
 * broker_token 존재 + broker_info.role === "admin" 일 때만 접근 허용
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const [isChecking, setIsChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("broker_token");
    const info = localStorage.getItem("broker_info");

    if (token && info) {
      try {
        const parsed = JSON.parse(info);
        setIsAdmin(parsed.role === "admin");
      } catch {
        setIsAdmin(false);
      }
    }
    setIsChecking(false);
  }, []);

  if (isChecking) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          color: "var(--text-muted)",
        }}
      >
        권한 확인 중...
      </div>
    );
  }

  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}
